import React from 'react'
import { Button } from 'react-bootstrap'
import './AppButton.css'

function AppButton({ variant = 'primary', className = '', children, ...rest }) {
    return (
        <Button {...rest} className={`appButton appButton--${variant} ${className}`.trim()}>
            {children}
        </Button>
    )
}

export default AppButton
